/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StillImageSubmissionPlanDTO } from '../models/StillImageSubmissionPlanDTO';
import type { StillImageSubmissionPlanDTOODataListResponse } from '../models/StillImageSubmissionPlanDTOODataListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StillImageSubmissionPlanService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns StillImageSubmissionPlanDTOODataListResponse Success
     * @throws ApiError
     */
    public static getStillImageSubmissionPlan(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<StillImageSubmissionPlanDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/StillImageSubmissionPlan',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param key 
     * @returns StillImageSubmissionPlanDTO Success
     * @throws ApiError
     */
    public static getStillImageSubmissionPlan1(
key: number,
): CancelablePromise<StillImageSubmissionPlanDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/StillImageSubmissionPlan/{key}',
            path: {
                'key': key,
            },
        });
    }

}
